"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const s=require("./index15.js");require("./index16.js");const a=require("@apollo/client");function i(e){const t=Object.create(null,{[Symbol.toStringTag]:{value:"Module"}});if(e){for(const n in e)if(n!=="default"){const r=Object.getOwnPropertyDescriptor(e,n);Object.defineProperty(t,n,r.get?r:{enumerable:!0,get:()=>e[n]})}}return t.default=e,Object.freeze(t)}const c=i(a);var u,l={},o=a.gql(u||(u=s.default([`
  query seatRequest {
    user {
      id
      featureSetId
      seatRequest {
        id
        status
        request {
          id
          seatType
          date
        }
        reminder {
          mostRecentDate
          count
        }
      }
      contributorRoleType
      team {
        id
        accountOwner {
          id
          email
          firstName
          lastName
        }
      }
    }
  }
`])));function d(e){var t=Object.assign({},l,e);return c.useQuery(o,t)}exports.SeatRequestDocument=o;exports.useSeatRequestQuery=d;
